export const calculateDateRanges = () => {
  const today = new Date();
  const last30Days = new Date();
  last30Days.setDate(today.getDate() - 30);

  const prevEnd = new Date(last30Days); // End of the previous period
  const prevStart = new Date(prevEnd); // Start of the previous period
  prevStart.setDate(prevEnd.getDate() - 30);

  return { last30Days, today, prevStart, prevEnd };
};

/**
 * Parses a date string in "DD/MM/YYYY" format and formats it to "DD-MMM-YYYY".
 * Example: "20/12/2025" -> "20-Dec-2025"
 * @param {string} dateString - The date string in "DD/MM/YYYY" format.
 * @returns {string} The formatted date string or the original string if invalid.
 */
export const formatDateToDisplay = (dateString) => {
  if (!dateString || typeof dateString !== 'string' || !dateString.includes('/')) {
    return dateString;
  }

  // 1. Convert DD/MM/YYYY to a reliably parsable format (YYYY-MM-DD)
  const parts = dateString.split('/');
  if (parts.length !== 3) {
      return dateString; // Invalid format
  }
  const [day, month, year] = parts;
  
  // Note: Using YYYY-MM-DD ensures correct parsing without time zone issues.
  const safeDateString = `${year}-${month}-${day}`; 
  const dateObj = new Date(safeDateString);

  // Check if the resulting Date object is valid
  if (isNaN(dateObj.getTime())) {
    return dateString;
  }

  // 2. Format the valid Date object to "DD-MMM-YYYY"
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: 'short', // e.g., 'Dec'
    year: 'numeric',
  }).format(dateObj);

  // The output of Intl.DateTimeFormat is usually "Dec 20, 2025". 
  // We need to re-order and replace spaces/commas with dashes.
  
  // A simple re-order and replace to get DD-MMM-YYYY
  const [monthStr, dayStr, yearStr] = formattedDate.replace(',', '').split(' ');

  return `${dayStr}-${monthStr}-${yearStr}`;
};